export const ACTIVITY = {
  HARDWARE_SETUP: 'HardwareSetup-v01'
}
